export const MAX_PRODUCTS = 3;

export const PRODUCT_SLOT_WIDTH = 163;

export const PRODUCT_SLOT_GAP = 16; // Gap between product slots

export const SENTIMENT_TYPE = {
    PROS: 'PROS',
    CONS: 'CONS'
};

export const MAX_SENTIMENTS = 3; // Maximum number of pros/cons to display
